import Cookies from 'js-cookie'

const TokenKey = 'Shop-Web-Token'
const ProjectKey = 'Shop-Web-Project'
const InviterKey = 'Shop-Web-Inviter'
const CompanyKey = 'Shop-Web-Company'

export function getInviter () {
  return Cookies.get(InviterKey + getProject())
}

export function setInviter (inviter) {
  return Cookies.set(InviterKey + getProject(), inviter)
}

export function getProject () {
  return Cookies.get(ProjectKey)
}

export function setProject (project) {
  return Cookies.set(ProjectKey, project)
}

export function getCompany () {
  return Cookies.get(CompanyKey + getProject())
}

export function setCompany (company) {
  return Cookies.set(CompanyKey + getProject(), company)
}

export function getToken () {
  return Cookies.get(TokenKey + getProject())
}

export function setToken (token) {
  return Cookies.set(TokenKey + getProject(), token)
}

export function removeToken () {
  return Cookies.remove(TokenKey + getProject())
}

export function getAppId () {
  return Cookies.get('appid')
}

export function setAppId (appid) {
  return Cookies.set('appid', appid)
}

export function getAvatar () {
  return Cookies.get('avatar')
}

export function setAvatar (avatar) {
  return Cookies.set('avatar', avatar)
}

export function removeAvatar () {
  return Cookies.remove('avatar')
}

export function getCredits () {
  return Cookies.get('credits')
}

export function setCredits (credits) {
  return Cookies.set('credits', credits)
}

export function removeCredits () {
  return Cookies.remove('credits')
}

export function getName () {
  return Cookies.get('name')
}

export function setName (name) {
  return Cookies.set('name', name)
}

export function removeName () {
  return Cookies.remove('name')
}

export function getTitle () {
  return Cookies.get('title')
}

export function setTitle (title) {
  return Cookies.set('title', title)
}

export function removeTitle () {
  return Cookies.remove('title')
}

export function getProjectImage () {
  return Cookies.get('projectImage')
}

export function setProjectImage (image) {
  return Cookies.set('projectImage', image)
}

export function removeProjectImage () {
  return Cookies.remove('projectImage')
}

export function getAddress () {
  const address = Cookies.get('address')
  return address ? JSON.parse(address) : null
}

export function setAddress (address) {
  return Cookies.set('address', address)
}

export function removeAddress () {
  return Cookies.remove('address')
}

export function getQueryString (queryName) {
  var query = decodeURI(window.location.search.substring(1))
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] == queryName) {
      return pair[1]
    }
  }
  return null
}

export function getDefaultShareURL() {
  let shareUrl = ''
  if (location.hostname === 'shop-dev.zoombin.com') {
    shareUrl =
      'https://shop-dev.zoombin.com/mobile' +
      '/#/details/storeDetails/' +
      '?inviterId=' +
      getToken() +
      '&project=' +
      getProject()
  } else if (location.hostname === 'shop.zoombin.com') {
    shareUrl =
      'https://shop.zoombin.com/mobile' +
      '/#/details/storeDetails/' +
      '?inviterId=' +
      getToken() +
      '&project=' +
      getProject()
  } else {
    shareUrl =
      'https://shop.zoombin.com/mobile' +
      '/#/details/storeDetails/' +
      '?inviterId=' +
      getToken() +
      '&project=' +
      getProject()
  }
  return shareUrl
}



// WEBPACK FOOTER //
// ./src/utils/auth.js